import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useBrandReducer = () => useSelector((state: ApplicationState) => state.brand);
